export default __webpack_public_path__ + "img/shape-circle.f172b5e6.svg";